import { Sync_standardSync, type Sync_Params } from '../Sync/Sync.standardSync'
import { IDB_syncParamsUnits, IDB_units } from '../IDB/IDB.dexie'
import { Serv_client } from '../Serv/Serv.client'
import { IDB_chunkedPut } from '../IDB/IDB.chunkedPut'
import { type KnownUnit, knownUnit } from '../../../app-core/lib/unit/unit'
import { DS_setData } from '../DS/DS.Data'
import { cloneSet } from '../../../shared/lib/functional/set.no-deps'
import { Cust_hasFeature } from '../Cust/Cust.hasFeature'
import type { TFullUnit } from '../../../shared/domain/units/types.no-deps'

export async function Unit_sync() {
    await Sync_standardSync({
        params: IDB_syncParamsUnits(),
        sync,
        write: (response) => Unit_writeUnits(response.units),
        clear: () => IDB_units().clear(),
    })
}

async function sync(params: Sync_Params) {
    const filterExpired = Cust_hasFeature('units/getAll.filter-expired')
    const response = await Serv_client.syncUnits(params.lastSyncTime, filterExpired)

    // Pass back teams unchanged just to have a consistent API with other sync endpoints
    return { ...response, teams: params.teams }
}

export async function Unit_writeUnits(units: TFullUnit[]) {
    if (units.length === 0) return
    const knownUnits = units.map(knownUnit)
    await IDB_chunkedPut(IDB_units(), knownUnits)
    updateActiveUnits(knownUnits)
}

/**
 * Keep track of all the units that aren't deleted
 */
export function updateActiveUnits(units: KnownUnit[]) {
    DS_setData('UpdateActiveUnits', ({ activeUnitIds }) => {
        activeUnitIds = cloneSet(activeUnitIds)

        for (const unit of units) {
            if (unit.isDeleted) {
                // If the unit is delete, remove from set
                activeUnitIds.delete(unit.id)
            } else {
                // Otherwise ensure that it's in the set
                activeUnitIds.add(unit.id)
            }
        }

        return { activeUnitIds }
    })
}
